import styled from 'styled-components';

export const MapStepColumnsStyle = {
  Container: styled.div``,
};
